import {ResourcesStorage} from '../../../../../viscomjs/load/ResourcesStorage';

export const Factory = () => {
    const settings = _getSettingsFromManifest(ResourcesStorage.instance().getItem('geometrySettings'));
    return stateName => {
        const stgs = settings[`geom--${stateName}`];
        return {
            geometry: ResourcesStorage.instance().getItem(`geom--${stateName}`),
            position: (stgs ? stgs.position : null) || {x: 0, y: 0, z: 0},
            rotation: (stgs ? stgs.rotation : null) || {x: 0, y: 0, z: 0}
        };
    };
};

const _getSettingsFromManifest = source => {
    const src = source.manifest;
    if (!src) return {};

    const tgt = {};
    let obj;
    let i;

    for (i = 0; i < src.length; i++) {
        obj = src[i];
        tgt[obj.name] = obj;
    }

    return tgt;
};

export default Factory;
